import { parsePhoneNumberFromString } from "libphonenumber-js/min";

/** Whether a stored value is a complete, dialable number. */
export function isPhoneNumber(value: string | undefined): boolean {
  const p = parsePhoneNumberFromString(value ?? "");
  return !!p && p.isValid();
}

/** A stored number as a person would read it: "+1 415 555 0100". */
export function formatPhone(value: string | undefined): string {
  const p = parsePhoneNumberFromString(value ?? "");
  return p ? p.formatInternational() : (value ?? "");
}
